// extracted by mini-css-extract-plugin
export default {"container":"tutorial_container__HMtnd","heading":"tutorial_heading__6-adj","video":"tutorial_video__1fAG-"};